import { PlayerRef } from '@remotion/player';
import React from 'react';
import {
  FEATURE_FULLSCREEN_CONTROL,
  FEATURE_JUMP_TO_NEXT_CLIP,
  FEATURE_JUMP_TO_NEXT_FRAME,
  FEATURE_JUMP_TO_PREVIOUS_CLIP,
  FEATURE_JUMP_TO_PREVIOUS_FRAME,
  FEATURE_LOOP_BUTTON,
  FEATURE_MUTE_BUTTON,
} from '../flags';
import { useAllItems } from '../utils/use-context';
import { FullscreenButton } from './fullscreen-button';
import { LoopButton } from './loop-button';
import { MuteButton } from './mute-button';
import { PlayPauseButton } from './play-pause';
import {
  GoToNextClipButton,
  GoToNextFrameButton,
  GoToPreviousClipButton,
  GoToPreviousFrameButton,
} from './seeking';

export const PlaybackBar: React.FC<{
  playerRef: React.RefObject<PlayerRef | null>;
}> = ({ playerRef }) => {
  const { items } = useAllItems();

  return (
    <div className="relative flex w-full shrink-0 items-center justify-between border-t border-t-sys-style-neutral-light bg-sys-bg-surface-1 px-sm py-2xs">
      {/* 좌측: 볼륨 */}
      <div className="flex min-h-px min-w-px flex-1 items-center">
        {FEATURE_MUTE_BUTTON && <MuteButton playerRef={playerRef} />}
      </div>

      {/* 중앙: 재생 컨트롤 */}
      <div className="flex shrink-0 items-center gap-4xs">
        {FEATURE_JUMP_TO_PREVIOUS_FRAME && (
          <GoToPreviousFrameButton playerRef={playerRef} />
        )}
        {FEATURE_JUMP_TO_PREVIOUS_CLIP && (
          <GoToPreviousClipButton
            playerRef={playerRef}
            items={items}
          />
        )}
        <PlayPauseButton playerRef={playerRef} />
        {FEATURE_JUMP_TO_NEXT_CLIP && (
          <GoToNextClipButton
            playerRef={playerRef}
            items={items}
          />
        )}
        {FEATURE_JUMP_TO_NEXT_FRAME && (
          <GoToNextFrameButton playerRef={playerRef} />
        )}
      </div>

      {/* 우측: 루프, 풀스크린 */}
      <div className="flex min-h-px min-w-px flex-1 items-center justify-end">
        {FEATURE_LOOP_BUTTON && <LoopButton />}
        {FEATURE_FULLSCREEN_CONTROL && (
          <FullscreenButton playerRef={playerRef} />
        )}
      </div>
    </div>
  );
};
